import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import AuthProvider from './providers/AuthProvider'
import ThemeContextProvider from './contexts/ThemeContext'
import { ConfigProvider } from './contexts/ConfigContext'
import App from './App'

// Filter out noisy console logs for debugging
const originalLog = console.log
const originalWarn = console.warn
const originalError = console.error
const originalInfo = console.info

// Function to check if a message should be filtered
const shouldFilter = (message) => {
  if (typeof message === 'string') {
    // Filter all MSAL/Auth related logs
    if (message.includes('[MSAL]') || 
        message.includes('MSAL') || 
        message.includes('msal') || 
        message.includes('@azure') ||
        message.includes('Microsoft') ||
        message.includes('BrowserCrypto') ||
        message.includes('BrowserPerformanceClient') ||
        message.includes('CacheManager') ||
        message.includes('AuthenticationResult') ||
        message.includes('SilentFlowClient') ||
        message.includes('checkMsalAuthStatus') ||
        message.includes('access token') ||
        message.includes('roles from access token') ||
        message.includes('created user object') ||
        message.includes('account object') ||
        message.includes('idTokenClaims')) {
      return true
    }
    
    // Filter Vite development logs
    if (message.includes('[vite]')) {
      return true
    }
    
    // Filter React Router warnings
    if (message.includes('React Router Future Flag Warning') ||
        message.includes('v7_startTransition') ||
        message.includes('v7_relativeSplatPath')) {
      return true
    }
    
    // Filter development/build logs
    if (message.includes('client.ts:')) {
      return true
    }
  }
  return false
}

// Override all console methods
console.log = (...args) => {
  if (!shouldFilter(args[0])) originalLog(...args)
}
console.warn = (...args) => {
  if (!shouldFilter(args[0])) originalWarn(...args)
}
console.error = (...args) => {
  if (!shouldFilter(args[0])) originalError(...args)
}
console.info = (...args) => {
  if (!shouldFilter(args[0])) originalInfo(...args)
}


// Base path is always root for all deployments
const basename = ''

ReactDOM.createRoot(document.getElementById('root')).render(
  // DISABLED STRICTMODE TO PREVENT DOUBLE RENDERS
  <BrowserRouter basename={basename}>
    <AuthProvider>
      <ThemeContextProvider>
        <ConfigProvider>
          <App />
        </ConfigProvider>
      </ThemeContextProvider>
    </AuthProvider>
  </BrowserRouter>
)